import { w3cwebsocket as W3CWebSocket } from 'websocket';

/**
 * These are the standard websocket states.
 * idle is added and is referring to the state
 * when no attempt is being made yet with the websocket server.
 */
export const WS_STATUS = {
  CONNECTING: 'connecting',
  OPEN: 'open',
  CLOSING: 'closing',
  CLOSED: 'closed',
  IDLE: 'idle',
};

const connectToWebsocket = ({
  serverLocation,
  setStatus,
  setLatestMessage,
}) => {
  setStatus(WS_STATUS.CONNECTING);

  /**
   * As soon the instance is initialized,
   * an attempt is being made to start the websocket connection.
   */
  const client = new W3CWebSocket(serverLocation);
  client.onerror = (error) => {
    // eslint-disable-next-line
    console.warn(error);
    setStatus(WS_STATUS.ERROR);
  };

  client.onopen = () => {
    if (client.readyState === client.OPEN) {
      setStatus(WS_STATUS.OPEN);
    }
  };

  /**
   * This event listener receives incoming websocket messages.
   */
  client.onmessage = (message) => {
    if (typeof message.data === 'string') {
      setLatestMessage(JSON.parse(message.data));
    }
  };

  client.onclose = () => {
    setStatus(WS_STATUS.CLOSED);
  };
};

export default connectToWebsocket;
